import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './styles/form-global.css';
import App from './App';

// Interceptor global: adjunta el token JWT a todas las peticiones axios
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Interceptor de respuesta: si el servidor responde 401, limpiar sesión y redirigir al login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (error.response.data?.fueraDeHorario) {
        sessionStorage.setItem('login_mensaje', error.response.data.error || 'Tu horario de acceso ha finalizado.');
      }
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
